import { writable } from 'svelte/store';
import * as Ramda from 'ramda';

function registerAccountStore() {
    let default_values = {
        step: 1,
        otp_type: "",
        otp_controller: {
            status: "enabled", //enable, disabled
            interval: null,
            recording_time: `03:00`,
            minutes: 3,
            seconds: 0,
            finish_interval: false
        },
        id_plan_selected: null,
        hasChanges: false,
        form: {
            interval: null,
            add_trial_end: false,
            accept_conditions: false,
            card_name_owner: null,
            stripeToken: null,
            id_plan: null,
            membership_type: null,
            first_name: null,
            last_name: null,
            email: null,
            password: null,
            password_repeat: null,
            coupon: null,
            dial: null,
            phone: null, 
            address: null,
            code_country: null,
            country: null,
            state: null,
            state_code: null,
            city: null,
            zip_code: null,
            provider_id: "stripe",
            code_phone_verify: null,
            turnstile_token: null,
            userFromCampaign: null,
            affiliate: null,
            credentials_application: null,
            lang: "es",
        },
    }

    const { subscribe, update, set } = writable({...default_values});
    const data = {
        subscribe: subscribe,
        set: ()=> set({...default_values}),
        update: update,
        updateField: (field, new_data) => {
            update((data) => {
                data[field] = new_data;
                return data;
            })
        },
        change_step: (number)=>{
            update((data)=>{
                data.step = number;
                return data;
            })
        },
        /**
         * 
         * @param {Object} object_data 
         */
        updateMultiple: function(object_data){
            let app = this;
            Object.values(object_data).map((value, key)=>{
                let field = Object.keys(object_data)[key];
                app.update_form(field, value);
            })
        },
        update_form: function(field, value){
            let app = this;
            update((data)=>{
                /*if(typeof data.form[field] === "undefined"){
                    throw(`The field ${field} does not exist in the store model.`)
                }*/
                data.form[field] = value;
                
                setTimeout(() => {
                    app.updateIfHasChanges();
                }, 10);
                return data;
            })
        },
        change_otp: (new_value) => {
            update((data) => {
                if(!new_value.search('whatsapp|sms') < 0){
                    console.error("El valor ingresado no esta permitido. Ingresa whatsapp o sms.");
                    return;
                }
                data.otp_type = new_value;
                return data;
            });
        },
        update_otp_controller(field, value){
            update((data) => {
                data.otp_controller[field] = value;
                return data;
            })
        },
        restart_otp(){
            update((data) => {
                data.otp_controller.minutes = 3;
                data.otp_controller.seconds = 0;   
                data.otp_controller.recording_time = `03:00`;     
                return data;
            });
        },
        start_time_recording(){
            let app = this;
            update((data) => {
                data.otp_controller.interval = setInterval(() => {
                    app.update_otp_controller("status", "disabled");
                    // data.otp_controller.finish_interval = false;
                    data.otp_controller.recording_time = app.process_interval(() => {
                        if(!data.otp_controller.interval) { return };
                        clearInterval(data.otp_controller.interval);
                        data.otp_controller.recording_time = `03:00`;
                        data.otp_controller.finish_interval = true;
                    });
                    // process_interval();
                }, 1000);
                return data;
            })
        },
        process_interval(func){
            let result = "";
            update((data) => {
                let mAux, sAux;
    
                if(data.otp_controller.seconds === 0 && data.otp_controller.minutes === 0) {
                    if (typeof func !== "function") {
                        return data;
                    }
                    func();
                    data.otp_controller.minutes = 3;
                    data.otp_controller.seconds = 0;
                    // data.otp_controller.status = "enabled"; // controller for restart Api
                    return data;
                }
                
                data.otp_controller.seconds--;
    
                if (data.otp_controller.seconds<0){
                    data.otp_controller.minutes--;
                    data.otp_controller.seconds=59;
                }
        
                if(data.otp_controller.seconds<10){
                    sAux="0"+data.otp_controller.seconds;
                }else{
                    sAux=data.otp_controller.seconds
                }
    
                if(data.otp_controller.minutes<10){
                    mAux="0"+data.otp_controller.minutes
                }else{
                    mAux=data.otp_controller.minutes
                }
        
                result = `${mAux}:${sAux}`;
                return data;
            });
            return result;
        },
        updateIfHasChanges: () => {
            update((data) => {
                const formWithoutLang = Ramda.omit(['lang'], data.form);

                let hasChanges = Object.values(formWithoutLang).some(value => value !== "" && value !== false && value !== null);
                data["hasChanges"] = hasChanges;
                return data;
            });
        },
        restore: () => {
            update((data) => {
                data = {
                    step: 1,
                    otp_type: "",
                    otp_controller: {
                        status: "enabled", //enabled, disabled
                        // finish_interval: false,
                        interval: null,
                        recording_time: `03:00`,
                        minutes: 3,
                        seconds: 0,
                        finish_interval: false
                    },
                    id_plan_selected: null,
                    hasChanges: false,
                    form: {
                        interval: null,
                        add_trial_end: false,
                        accept_conditions: false,
                        card_name_owner: null,
                        stripeToken: null,
                        id_plan: null,
                        membership_type: null,
                        first_name: null,
                        last_name: null,
                        email: null,
                        password: null,
                        password_repeat: null,
                        coupon: null,
                        dial: null,
                        phone: null, 
                        address: null,
                        code_country: null,
                        country: null,
                        state: null,
                        state_code: null,
                        city: null,
                        zip_code: null,
                        code_phone_verify: null,
                        turnstile_token: null,
                        userFromCampaign: null,
                        affiliate: null,
                        credentials_application: null,
                        lang: "es",
                    },
                }
                return data;
            })
        }
    }

    return data;
}

const RegisterAccountStore = registerAccountStore();
export {RegisterAccountStore};